import { render, staticRenderFns } from "./UserNewForm.vue?vue&type=template&id=15b9a5d2&scoped=true&"
import script from "./UserNewForm.vue?vue&type=script&lang=js&"
export * from "./UserNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b9a5d2",
  null
  
)

export default component.exports